(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    function refreshCartDrawer(cartData) {
      fetch('/?sections=cart-drawer-section', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data['cart-drawer-section'] || '';
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newInner = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
          var oldInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
          if (newInner && oldInner) {
            oldInner.className = newInner.className;
            oldInner.innerHTML = newInner.innerHTML;
          }
          if (cartData && cartData.item_count !== undefined) {
            var badges = document.querySelectorAll('[data-cart-count]');
            badges.forEach(function(b) {
              b.textContent = cartData.item_count;
              b.style.display = cartData.item_count > 0 ? 'flex' : 'none';
            });
          }
        })
        .catch(function(err) { console.error('Cart refresh error:', err); });
    }

    // Remove item via AJAX + refresh drawer via Section Rendering API
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.eldaly-cart-item__remove');
      if (!btn || btn.classList.contains('is-removing')) return;
      e.preventDefault();
      e.stopPropagation();

      var line = parseInt(btn.getAttribute('data-line'));
      btn.classList.add('is-removing');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
        .then(function(resp) { return resp.json(); })
        .then(function(cart) {
          refreshCartDrawer(cart);
        })
        .catch(function(err) {
          console.error('Cart remove error:', err);
          btn.classList.remove('is-removing');
        });
    });

    // Quantity increment / decrement via AJAX
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.eldaly-cart-item__qty-btn');
      if (!btn || btn.classList.contains('is-disabled')) return;
      e.preventDefault();
      e.stopPropagation();

      var qtyWrap = btn.closest('.eldaly-cart-item__qty');
      if (!qtyWrap || qtyWrap.classList.contains('is-updating')) return;
      var line = parseInt(qtyWrap.getAttribute('data-line'));
      var currentQty = parseInt(qtyWrap.getAttribute('data-qty'));
      var action = btn.getAttribute('data-action');
      var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);

      qtyWrap.classList.add('is-updating');
      var valEl = qtyWrap.querySelector('.eldaly-cart-item__qty-val');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
        .then(function(resp) { return resp.json(); })
        .then(function(cart) {
          qtyWrap.classList.remove('is-updating');
          refreshCartDrawer(cart);
        })
        .catch(function(err) {
          console.error('Cart quantity error:', err);
          qtyWrap.classList.remove('is-updating');
          if (valEl) valEl.textContent = currentQty;
        });
    });

    // Listen for cart add/update events (shopify:cart:lines-update is the standard event name)
    document.addEventListener('shopify:cart:lines-update', function(event) {
      if (event.action === 'add') {
        var p = event.promise;
        if (p && p.then) {
          p.then(function(res) {
            refreshCartDrawer(res && res.cart ? res.cart : null);
          }).catch(function() {});
        } else {
          refreshCartDrawer();
        }
      }
    });

    // Init: hide cart count badge if 0
    document.querySelectorAll('[data-cart-count]').forEach(function(b) {
      var count = parseInt(b.textContent.trim(), 10) || 0;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
